import { render, staticRenderFns } from "./HeaderOtherMenuItem.vue?vue&type=template&id=0d90ba2e&"
import script from "./HeaderOtherMenuItem.vue?vue&type=script&lang=js&"
export * from "./HeaderOtherMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports